import { useState } from 'react';

export function useErrorBoundary() {
  const [_width, setWidth] = useState(0);

  window.addEventListener('resize', function () {
    setWidth(this.innerWidth);
  });

  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        fontSize: '2rem',
        color: 'white',
      }}
    >
      Portfolio is only available on Desktop view
    </div>
  );
}
